import styled from 'styled-components';
import React from 'react';

export const TagDescriptionSC = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  
  .star-container {
    margin-left: 2px;
  }

  .description-star {
    margin-right: 3px;
  }
`;

export const TagDescriptionDotSC = styled.div<{
  background: React.CSSProperties['background'];
}>`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin-left: 4px;
  margin-right: 4px;
  background: ${({ background }) => background};
`;

export default styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  min-height: ${({ theme }) => (theme.responsive ? '122px' : '125px')};
  margin-top: 24px;
`;
